document.addEventListener("DOMContentLoaded", function () {
  function setupLoadMoreLess(
    data,
    initialLimit,
    viewMoreButtonId,
    viewLessButtonId,
    listId,
  ) {
    let currentOffset = initialLimit;

    const viewMoreButton = document.getElementById(viewMoreButtonId);
    const viewLessButton = document.getElementById(viewLessButtonId);
    const list = document.getElementById(listId);

    // Return early if any of the elements are not found
    if (!viewMoreButton || !viewLessButton || !list) {
      return;
    }

    viewMoreButton.addEventListener("click", function () {
      const additionalItems = data.slice(
        currentOffset,
        currentOffset + initialLimit,
      );

      additionalItems.forEach((item) => {
        const listItem = document.createElement("li");
        listItem.className = "list-inline-item fw-bolder my-3 me-2";
        listItem.innerHTML = `<a href="#" class="text-decoration-none point-event-none">${item}</a>`;
        list.appendChild(listItem);
      });

      currentOffset += initialLimit;

      if (currentOffset > initialLimit) {
        viewLessButton.style.display = "inline-block";
      }

      if (currentOffset >= data.length) {
        viewMoreButton.style.display = "none";
      }
    });

    viewLessButton.addEventListener("click", function () {
      const items = list.querySelectorAll("li");
      const itemsToRemove = Array.from(items).slice(initialLimit);

      itemsToRemove.forEach((item) => {
        list.removeChild(item);
      });

      currentOffset = initialLimit;

      viewLessButton.style.display = "none";

      if (currentOffset < data.length) {
        viewMoreButton.style.display = "inline-block";
      }
    });
  }

  if (document.getElementById("view-more-counties")) {
    setupLoadMoreLess(
      apiData.counties,
      20,
      "view-more-counties",
      "view-less-counties",
      "county-list",
    );
  }

  if (document.getElementById("view-more-cities")) {
    setupLoadMoreLess(
      apiData.cities,
      20,
      "view-more-cities",
      "view-less-cities",
      "city-list",
    );
  }
  if (document.getElementById("view-more-zip-codes")) {
    setupLoadMoreLess(
      apiData.zipCodes,
      45,
      "view-more-zip-codes",
      "view-less-zip-codes",
      "zip-code-list",
    );
  }
});
